var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoCertified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "45px",
    height: "45px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFEB3B;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#1D1D1B;stroke:#1D1D1B;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#1D1D1B;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st5{fill:#90A4AE;}\r\n\t.st6{fill:none;stroke:#1D1D1B;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st7{fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 6.4,
    className: "st1",
    width: 25.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Livello_46",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.9,10.4c0-1.1-0.9-2-1.9-2s-2,0.9-2,2s0.9,1.9,1.9,1.9S7.9,11.4,7.9,10.4 M3.5,22.5 C3.5,22.5,3.4,22.5,3.5,22.5l23.1,0.1l0,0l-7.9-10.8c0,0-0.9-1.3-1.9,0l-4.9,6.7L10.1,16c0,0-0.9-1.3-1.9,0L3.5,22.5z M27.4,23.3 H2.6V6.7h24.7L27.4,23.3L27.4,23.3z M28.4,23.8V6.2c0-0.3-0.2-0.5-0.5-0.5H2.1c-0.3,0-0.5,0.2-0.5,0.5v17.6c0,0.3,0.2,0.5,0.5,0.5 h25.8C28.2,24.3,28.4,24.1,28.4,23.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 3.3,
    transform: "matrix(0.2588 -0.9659 0.9659 0.2588 -3.3156 25.5831)",
    className: "st4",
    width: 20.7,
    height: 23.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 3.9,
    transform: "matrix(0.2589 -0.9659 0.9659 0.2589 -1.6955 24.7446)",
    className: "st5",
    width: 13.9,
    height: 19.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "6.8,7 7.5,4.2 26.7,9.4 24.2,18.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "6.4,8.6 3.9,17.7 23.1,22.8 23.7,20.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5,14 4.1,17.4 23,22.4 11.4,11.8 9.5,11.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "10.6,12 10.6,11.5 10.3,11.4 10.3,11.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "10.7,12.9 10.7,12.4 10.3,12.3 10.3,12.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "10.8,13.2 10.9,14 10.3,13.8 10.3,13.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "11,14.6 11.2,16.1 10.3,15.9 10.3,14.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "11.2,17.1 11.5,19.3 10.3,19 10.3,16.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCertified);
export default __webpack_public_path__ + "static/media/photo_certified.bbcab2c900ccd383c92eec03d78bd473.svg";
export { ForwardRef as ReactComponent };